/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1PersonIdAddressesAddresspersonid202,
  DeleteApiV1PersonIdAddressesAddresspersonid401,
  DeleteApiV1PersonIdAddressesAddresspersonid404,
  DeleteApiV1PersonIdAddressesAddresspersonid500,
  DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse,
  DeleteApiV1PersonIdAddressesAddresspersonidPathParams,
} from "../../types/personRegisterController/DeleteApiV1PersonIdAddressesAddresspersonid.ts";

export const deleteApiV1PersonIdAddressesAddresspersonidPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    addressPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonidPathParams>;

/**
 * @description Endereço excluído.
 */
export const deleteApiV1PersonIdAddressesAddresspersonid202Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonid202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1PersonIdAddressesAddresspersonid401Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1PersonIdAddressesAddresspersonid404Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1PersonIdAddressesAddresspersonid500Schema =
  z.any() as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonid500>;

export const deleteApiV1PersonIdAddressesAddresspersonidMutationResponseSchema =
  z.lazy(
    () => deleteApiV1PersonIdAddressesAddresspersonid202Schema,
  ) as unknown as ToZod<DeleteApiV1PersonIdAddressesAddresspersonidMutationResponse>;
